import request from '@/utils/request';

// 调整数据一览
export function getViewList(values) {
  return request('/manualOperation/queryPage', {
    method: 'POST',
    data: values,
  });
}
